import React, { useRef } from 'react'
import ApiKeyContainer from './container'
import { AdminContainer } from '../'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { LimitFeatureButton } from 'components/LimitFeatureButton'

export default function AdminApiKey() {
  const openApiKeyFormModalRef = useRef(null)

  return (
    <React.Fragment>
      <PageHeaderContainer
        title="API keys"
        rightSlot={
          <LimitFeatureButton
            handleClick={() => openApiKeyFormModalRef.current?.()}
            buttonText="New API key"
            loading={false}
          />
        }
      />
      <AdminContainer>
        <ApiKeyContainer onModalReady={(ref) => (openApiKeyFormModalRef.current = ref)} />
      </AdminContainer>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/ApiKey/index.js